<template>
  <i-mdi-exit-to-app />
</template>
